module.exports = __webpack_public_path__ + "static/img/health1.0e90a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/health1.png
// module id = 0eRh
// module chunks = 0